<template>
  <BaseTableWrapper>
    <template #top-buttons>
      <div class="float-right mb-1">
        <router-link tag="button" :to="{ name: 'EXCMRelationCategoryCreate' }" class="btn btn-sm btn-primary">{{ $t('buttons.create') }}</router-link>
      </div>
    </template>
    <template #filtering></template>
    <template #body>
      <div v-if="isLoading">
        <Loader></Loader>
      </div>
      <div v-else-if="!isLoading && items.length === 0">
        {{ $t('notifications.noData') }}
      </div>
      <div v-else>
        <table class="table table-sm table-responsive-md table-striped table-hover">
          <thead>
          <tr>
            <th>{{ $t('views.documenttype.list.title') }}</th>
            <th style="width: 5%" colspan="1" />
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="item in items"
            :key="item['@id']">
            <td>
              {{item.title}}
            </td>
            <td>
              <div class="btn-group">
                <router-link
                  tag="button"
                  class="btn btn-link fa fa-search fa-lg"
                  :to="{ name: 'EXCMRelationCategoryShow', params: { id: item['@id'] }}"
                ></router-link>
                <router-link
                  tag="button"
                  class="btn btn-link fa fa-edit fa-lg"
                  :to="{ name: 'EXCMRelationCategoryUpdate', params: { id: item['@id'] }}"
                ></router-link>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-if="view">
        <Pagination :view="view" @getPage="getPage($event)"></Pagination>
      </div>
    </template>
  </BaseTableWrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import Pagination from '@/components/Dashboard/Layout/Pagination'
import Loader from '@/components/Dashboard/Layout/Loader'

export default {
  name: 'List',
  components: {
    BaseTableWrapper,
    Pagination,
    Loader
  },

  computed: {
    ...mapGetters({
      error: 'excmrelationcategory/list/error',
      items: 'excmrelationcategory/list/items',
      isLoading: 'excmrelationcategory/list/isLoading',
      view: 'excmrelationcategory/list/view'
    })
  },
  created () {
    this.getPage()
  },

  methods: mapActions({
    getPage: 'excmrelationcategory/list/getItems'
  })
}
</script>

<style scoped>

</style>
